import { render, staticRenderFns } from "./DeleteRecipeButton.vue?vue&type=template&id=14366c1f"
import script from "./DeleteRecipeButton.vue?vue&type=script&lang=js"
export * from "./DeleteRecipeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports